import { Box, styled } from '@mui/material';
import color from 'src/theme/color';

export const Container = styled(Box)`
    margin: 50px auto;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${color.blackRock};
    width: 80%;
    border-radius: 5px;
`;

export const RatingSection = styled(Box)`
    align-items: center;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;
    padding: 30px 10px;
    width: 40%;
`;

export const RatingBox = styled(Box)`
    margin: 20px 0;
    gap: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ButtonSection = styled(Box)`
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;
`;

export const MergePrompt = styled(Box)`
    align-items: center;
    color: ${color.white};
    display: flex;
    flex-direction: column;
    font-family: Inter;
    font-size: 18px;
    gap: 8px;
    padding: 40px 20px 20px 20px;
    text-align: center;
`;

export const MergePromptTitle = styled('span')`
    color: ${color.white};
    font-family: Inter;
    font-size: 22px;
    font-weight: 600;
`;

export const MergePromptSubtitle = styled('span')`
    color: ${color.white70};
    font-family: Inter;
    font-size: 14px;
    line-height: 20px;
    max-width: 480px;
`;
